import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import ZoneService from "../../../../services/ZoneService";
import { Badge } from "react-bootstrap";
import { usePermissions } from "../../../common/permissions";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const zoneService = new ZoneService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">
				{lang === "en" ? item?.name_en : item?.name_ar}
			</td>
			<td className="text-wrap-mode">{Translate[lang][item?.price_per]}</td>
			<td className="text-wrap-mode">
				{Number(item?.price)?.toFixed(3)} {Translate[lang].kwd}
			</td>
			<td className="text-wrap-mode">
				{!!item?.quick_valet_price
					? Number(item?.quick_valet_price)?.toFixed(3)
					: "-"}{" "}
				{!!item?.quick_valet_price ? Translate[lang].kwd : ""}
			</td>
			<td className="text-wrap-mode">
				{lang === "en"
					? item?.governorate?.name_en
					: item?.governorate?.name_ar}
			</td>
			<td className="text-wrap-mode">
				{lang === "en" ? item?.area?.name_en : item?.area?.name_ar}
			</td>
			<td className="text-wrap-mode">{item?.block}</td>
			<td className="text-wrap-mode">{item?.street}</td>
			<td className="text-wrap-mode">
				{item?.location?.includes("https://maps.app.goo.gl") ? (
					<a href={item?.location} target="_blank" rel="noreferrer">
						{Translate[lang].location}
					</a>
				) : (
					item?.location
				)}
			</td>
			<td className="text-wrap-mode">{item?.floor || "-"}</td>
			<td
				className="text-wrap-mode"
				style={{
					display: "grid",
					gridTemplateColumns: "auto auto auto auto",
					gap: "8px",
				}}>
				{item?.admin_zones?.map((res) => {
					return <Badge variant="primary light">{res?.user?.username}</Badge>;
				}) || "-"}
			</td>
			<td className="text-wrap-mode">
				{item?.number_of_available_parking || "-"}
			</td>

			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("zone") && (
						<img
							src={editIcon}
							onClick={() => {
								navigate("/add-zone", { state: item });
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("zone") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "en" ? item?.name_en : item?.name_ar}
					deletedItem={item}
					modelService={zoneService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
